// extracted by mini-css-extract-plugin
export default {"para":"Chapter_para__PS72P","videos":"Chapter_videos__ZQS1L"};